import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default function ButtonGroup({ align, children, className }) {
  const classNames = cn(
    'c-button-group',
    { [`c-button-group--${align}`]: align },
    className
  )

  return (
    <div className={classNames}>
      {children}
    </div>
  )
}

ButtonGroup.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

ButtonGroup.defaultProps = {
  align: null,
  className: null,
}
